module.exports = __webpack_public_path__ + "static/img/gaozhonglishi5.44c6417f.jpg";